// Livewire 3 ships and starts its own Alpine instance. We must NOT import or
// start Alpine ourselves (doing so causes "multiple instances of Alpine"
// errors). Instead we register our Alpine plugins on Livewire's Alpine once it
// is initialised.
import Focus from '@alpinejs/focus'
import Tooltip from '@ryangjchandler/alpine-tooltip'

document.addEventListener('livewire:init', () => {
    window.Alpine.plugin(Focus)
    window.Alpine.plugin(Tooltip)
})
